import { Link } from "@tanstack/react-router";

export default function AppleHealthConnect() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-8 flex-col gap-3">
      <span className="text-[3rem]">📱</span>
      <h1 className="text-text text-[1.5rem] font-black text-center">Apple Health</h1>
      <p className="text-text-muted text-base text-center leading-6 max-w-[20rem]">
        Apple Health is only available on iOS devices. Download the FootSlapping iOS app and tap the
        Apple Health card in settings to connect.
      </p>
      <a href="https://apps.apple.com/app/id6781928157" target="_blank" rel="noopener noreferrer">
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
          alt="Download on the App Store"
          className="h-[2.75rem] w-auto"
        />
      </a>
      <Link
        to="/dashboard"
        className="bg-aqua rounded-[16px] px-5 py-3 no-underline shadow-[1px_1px_0px_0px_#1c1b2e]"
      >
        <span className="text-white font-extrabold text-[0.9375rem]">Back to Dashboard</span>
      </Link>
    </div>
  );
}
